import React, { useRef } from 'react';
import styles from '../drapatriciandrade/drapatriciandrade.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado from '../../components/LinkPersonalizado/linkPersonalizado.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';
import DoctorIcon from '../../icons/doctorIcon.tsx';
import TopLeftImage from './src/top-left.png';
import BottomLeftImage from './src/bottom-right.png';

const Drapatriciandrade: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);

    return (
        <div className={styles.drapatriciandrade}>
            <div className={styles["body-thunder"]}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["top-left-image-wrapper"]}>
                    <img
                        className={styles["top-left-image"]}
                        src={TopLeftImage}
                        alt="Top Left Image"
                    />
                </div>
                <div className={styles["bottom-right-image-wrapper"]}>
                    <img
                        className={styles["bottom-right-image"]}
                        src={BottomLeftImage}
                        alt="Bottom Right Image"
                    />
                </div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mb-0">PATRICIA ANDRADE</h1>
                    <p className="mb-3">ENFERMEIRA ESTETA</p>
                    <div className={styles.links}>
                        <LinkPersonalizado
                            href="https://wa.me/5517997690033?text=Olá, gostaria de agendar uma consulta."
                            title="Agendar consultas"
                            icon={<WhatsappIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://wa.me/5517997690033?text=Olá, gostaria de agendar um voucher."
                            title="Agendar voucher"
                            icon={<WhatsappIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://chat.whatsapp.com/GdDaJyY5uNh3p1WgKx1bmS"
                            title="Grupo Vip"
                            icon={<WhatsappIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://maps.app.goo.gl/rh71TzKpqi6FQYnY6"
                            title="Localização"
                            icon={<MapsIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://www.instagram.com/drapatriciandrade?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://drapatriciaandradeestetica.com.br/"
                            title="Site"
                            icon={<SiteIcon height="32" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://api.whatsapp.com/send/?phone=5538991570858&text&type=phone_number&app_absent=0"
                            title="Fale com Dr. Mesaque"
                            icon={<DoctorIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                    </div>
                    <div className="mt-5">
                        <img width={150} src={require("./src/logo_footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drapatriciandrade;
